import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
    routes : [
      { path: "/book/:code", name: "간편예약샘플", component: () => import(/* webpackChunkName: "SimplyE" */ "../views/Book/Main")},
      { path: "/book_success/:code", name: "간편예약설공", component: () => import(/* webpackChunkName: "SimplyS" */ "../views/Book/Success")},
      { path: "/info", name: "간편예약설공인", component: () => import(/* webpackChunkName: "SimplyI" */ "../views/Book/Info")},
      ({ path: "/document",name: "문서관리" ,component: () => import(/* webpackChunkName: "my-document" */ "../views/Document/Main")}),
      ({ path: "/myDocument",name: "서류" ,component: () => import(/* webpackChunkName: "my-document" */ "../views/MyDocumentView")}),
      ({ path: "/reservation",name: "예약 확인" ,component: () => import(/* webpackChunkName: "my-reservation" */ "../views/Reservation/Main")}),
      ({ path: "/mailing/:code",name: "메일링" ,component: () => import(/* webpackChunkName: "mailling" */ "../views/Mailing/Link")}),
      ({ path: "/link/:code",name: "메일링" ,component: () => import(/* webpackChunkName: "mailling" */ "../views/Mailing/Link")}),
      ({ path: "/document/detail/:code",name: "문서관리" ,component: () => import(/* webpackChunkName: "my-document-detail" */ "../views/Document/DocumentDetail")}),
      ({ path: "/question/detail/:code",name: "질문지관리" ,component: () => import(/* webpackChunkName: "my-question-detail" */ "../views/Document/QuestionDetail")}),
      ({ path: "/assessment/detail/:code",name: "검사지관리" ,component: () => import(/* webpackChunkName: "my-assessment-detail" */ "../views/Document/AssessmentDetail")}),
      ({ path: "/gui/assessment/detail/:code",name: "가이던스 검사지관리" ,component: () => import(/* webpackChunkName: "gui-assessment-detail" */ "../views/Document/GuiAssessmentDetail")}),
    ]
});

export default router;

